import _ from 'lodash';

export default function getReferralInfo() {
  const referral = localStorage.getItem('referral');
  if (_.isNil(referral)) {
    return null;
  }
  const decodedBase64 = atob(decodeURI(referral));
  return JSON.parse(decodedBase64);
}
